import { requestCreator, UnknownError } from "../../common/actions/VisitApi";

export interface CreateSupportParams {
  projectId: number | string;
}

export const requestToCreateSupport = requestCreator<CreateSupportParams, null, UnknownError>(params => ({
  path: `/api/v2/project_supports`,
  method: "POST",
  body: {
    project_support: {
      project_id: params.projectId,
    },
  },
}));



// WEBPACK FOOTER //
// ./frontend/src/project_supports/api/index.ts